import React from 'react';
import ReactDOM from 'react-dom';
import {
  ContainerModalTarjetaInactiva, Overlay,
  SectionModal, ContenedorIconos, Icono, IconoCerrarInactiva,
  ContenedorConfronta,
  ContenedorPregunta,
  TextoModalInactivo,
  BotonTarjetaInactiva,
  TituloModalTarjetaInactiva
} from '../styles';

const ModalTarjetaInactiva = ({ onClose, numeroTarjeta }) => {
  
  const handleExit = () => {
    onClose()
  }

  const tarjetaInactiva = numeroTarjeta.mask.slice(-4);
  
  return ReactDOM.createPortal(
    <Overlay>
      <ContainerModalTarjetaInactiva>
        <SectionModal>
                  <ContenedorIconos>
                    <Icono
                      src={
                        process.env.AWS_MULTIMEDIA_S3 +
                        '/dashboard/modal_icons/warning.png'
                      }
                      alt="icono_warning"
                    />
          </ContenedorIconos>
          <IconoCerrarInactiva>
            <i onClick={()=> onClose()} className='material-icons'>close</i>
          </IconoCerrarInactiva>
            <TituloModalTarjetaInactiva>
              Tu tarjeta *****{tarjetaInactiva} fue inactivada
          </TituloModalTarjetaInactiva>
          <ContenedorConfronta>
            <ContenedorPregunta>
              <TextoModalInactivo>
              Por razones de seguridad establecidas por la franquicia, tu medio de pago ha sido inactivado, por favor actualízalo ahora.
              </TextoModalInactivo>
            </ContenedorPregunta>
            <BotonTarjetaInactiva onClick={handleExit}>Actualizar</BotonTarjetaInactiva>
          </ContenedorConfronta>
       </SectionModal>
      </ContainerModalTarjetaInactiva>
    </Overlay>, document.body
  );
};

export default ModalTarjetaInactiva;
